// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.mpcvault.broswerplugin",
    name: "MPCVault | Team crypto wallet",
    homepage: "https://mpcvault.com",
    image_id: "3cbf71ea-c90b-427c-6b2c-a9a7c7c0d500",
    app: {
        browser: "https://console.mpcvault.com",
        ios: "https://apps.apple.com/us/app/mpcvault/id1622756458",
        android: "https://play.google.com/store/apps/details?id=com.mpcvault.mobileapp.android",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/mpcvault/jgfmfplofjigjfokigdiaiibhonfnedj",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.mpcvault.broswerplugin",
    mobile: {
        native: "com.mpcvault.mobileapp://wccallback",
        universal: "https://ulink.mpcvault.com/wccallback",
    },
    desktop: {
        native: "com.mpcvault.mobileapp://wccallback",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map